// extracted by mini-css-extract-plugin
export default {"plans":"ChangePlan_plans__avzkd","plan":"ChangePlan_plan__JsHV2","planDescription":"ChangePlan_planDescription__Yrga7","planButtons":"ChangePlan_planButtons__ZLbx1"};